import PermissionsApiClient from '../api/PermissionsApiClient';

class PermissionsService {
    public async getUserPermissions() {
        return await PermissionsApiClient.getUserPermissions();
    }
}

export default new PermissionsService();